import { motion } from 'framer-motion';
import { Play } from 'lucide-react';

const DemoSection = () => {
  return (
    <section id="demo" className="relative py-24 lg:py-32 bg-[#0d0d0f]">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, rgba(255,255,255,0.05) 1px, transparent 0)`,
          backgroundSize: '40px 40px',
        }} />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <span className="inline-block font-mono text-xs uppercase tracking-widest text-[#00f5d4] mb-4">
            Product Demo
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            Watch XtraGlass in
            <span className="text-[#d987ff]"> Action</span>
          </h2>
          <p className="text-lg text-white/60 max-w-2xl mx-auto">
            Take a tour of the app and see how easy it is to discover your next epic night out
          </p>
        </motion.div>

        {/* Video Container */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="relative max-w-4xl mx-auto"
        >
          {/* Glow Effect */}
          <div className="absolute -inset-4 bg-gradient-to-r from-[#ff84e4]/20 via-[#d987ff]/20 to-[#00f5d4]/20 rounded-3xl blur-2xl" />
          
          {/* Video Wrapper */}
          <div className="relative rounded-2xl overflow-hidden bg-black/50 border border-white/10">
            <div className="aspect-video">
              <iframe
                className="w-full h-full"
                src="https://www.youtube.com/embed/mQYhwGnjfEk?si=9WUpgoDvVJhTw-ya"
                title="XtraGlass Demo"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
          </div>

          {/* Floating Elements */}
          <motion.div
            className="absolute -top-6 -left-6 glass px-4 py-3 rounded-xl hidden lg:block"
            animate={{ y: [0, -8, 0] }}
            transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
          >
            <div className="flex items-center gap-2">
              <Play size={16} className="text-[#ff84e4]" fill="currentColor" />
              <span className="font-mono text-xs text-white/80">Live Demo</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default DemoSection;